import React from 'react';
import clsx from 'clsx';
import styles from './ModalButton.module.scss';

interface ModalButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  type: 'button' | 'submit';
  variant: 'filled' | 'filled-grey' | 'outline';
  disabled?: boolean;
  onClick?: () => void;
  'data-testid'?: string;
}

const ModalButton: React.FC<ModalButtonProps> = ({ type, variant, className, disabled, children, onClick, 'data-testid': testId }) => (
  <button
    type={type === 'submit' ? 'submit' : 'button'}
    disabled={disabled}
    className={clsx(styles.button, styles[variant], className)}
    onClick={onClick}
    data-testid={testId}
  >
    {children}
  </button>
);

export default ModalButton;
